import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  portrait: {},
  comingUpTypography: { fontSize: 26, marginTop: theme.spacing(4) },
  contentBox: {
    width: 360,
    height: '100%',
    '&$portrait': {
      '@media (max-width: 1023px)': {
        width: 300
      },
      '@media (max-width: 767px)': {
        width: '100%'
      }
    }
  },
  chatListWrapper: {
    height: '100%',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/Content/styles.js